import { Link } from "react-router-dom";
import { LogoMark } from "@/components/site/Logo";
import { MaskLine } from "@/components/site/motion";
import { IMAGES } from "@/lib/site";

export const AuthShell = ({ kicker, lines, testid, children }) => (
  <section className="grid min-h-screen lg:grid-cols-2" data-testid={testid}>
    <div className="relative flex flex-col justify-between overflow-hidden border-b border-line p-6 sm:p-8 lg:border-b-0 lg:border-r lg:p-12">
      <img src={IMAGES.studioMic} alt="" aria-hidden className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-20 grayscale" />
      <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" />
      <Link to="/" className="relative flex items-center gap-2.5" data-testid="account-home-link">
        <LogoMark className="h-8 w-8" />
        <span className="font-display text-sm font-black tracking-[0.2em]">SFUMO</span>
      </Link>
      <h1 className="relative my-12 font-display text-4xl font-black uppercase leading-[0.9] tracking-tight sm:text-5xl lg:my-16 lg:text-7xl">
        {lines.map((l, i) => (
          <MaskLine key={l} onLoad delay={i * 0.1} className={i === lines.length - 1 ? "text-acid" : ""}>{l}</MaskLine>
        ))}
      </h1>
      <p className="relative font-mono text-[11px] uppercase tracking-[0.25em] text-bone/70">{kicker}</p>
    </div>
    <div className="flex items-center p-6 sm:p-8 lg:p-16">
      <div className="w-full max-w-md">{children}</div>
    </div>
  </section>
);

export const AuthLink = ({ to, testid, children }) => (
  <Link to={to} data-testid={testid} className="text-bone underline decoration-bone/30 underline-offset-4 transition-colors hover:text-acid hover:decoration-acid">
    {children}
  </Link>
);
